<script>
import { getIconPath as getImgPath } from "@/utils/getCorrectPath";

export default {
  name: "PauseSubscriptionModal",

  props: {
    pauseSubscription: {
      type: Function,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      getImgPath: getImgPath,
      selectedMonths: 1,
      options: [],
    };
  },

  computed: {
    monthOptions() {
      return [
        {
          value: 1,
          text: this.$t("account.subscription.pause.month", { count: 1 }),
        },
        {
          value: 2,
          text: this.$t("account.subscription.pause.months", { count: 2 }),
        },
        {
          value: 3,
          text: this.$t("account.subscription.pause.months", { count: 3 }),
        },
      ];
    },

    computedDate() {
      const date = new Date();
      date.setMonth(date.getMonth() + this.selectedMonths);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    },
  },

  methods: {
    async pause() {
      const success = await this.pauseSubscription(this.selectedMonths);

      if (success) {
        this.$egModal.hide("pause_subscription_modal");
      }
    },
  },
};
</script>

<template>
  <eg-modal
    id="pause_subscription_modal"
    :title="$t('account.subscription.pause.title')"
    centered
    no-stacking
  >
    <div class="img-content">
      <img
        v-if="getImgPath('pause-subscription')"
        :src="getImgPath('pause-subscription')"
        class="item-icon"
        alt="icon"
      />
    </div>

    <div class="selection-block">
      <div class="selection">
        <div>{{ $t("account.subscription.pause.pausedFor") }}</div>
        <eg-b-form-select
          v-model="selectedMonths"
          :options="monthOptions"
          data-testid="month-select"
        />
      </div>

      <div class="renewal-info">
        <div class="text">
          {{ $t("account.subscription.pause.automaticallyRenew") }}
        </div>
        <div class="date">{{ computedDate }}</div>
      </div>
    </div>

    <div class="d-flex flex-column gap-3">
      <div>
        {{ $t("account.subscription.pause.description") }}
      </div>
      <div>
        {{ $t("account.subscription.pause.theUserHas") }}
        <span class="bold-text">
          {{ $t("account.subscription.pause.only1Opportunity") }}
        </span>
        {{ $t("account.subscription.pause.toSuspend") }}
      </div>
    </div>

    <template #modal-footer="{ close }">
      <eg-button type="secondary" @click="close">
        {{ $t("account.subscription.pause.noPause") }}
      </eg-button>

      <eg-button
        :loading-text="$t('account.subscription.pause.pausing')"
        :is-loading="loading"
        @click="pause"
      >
        {{ $t("account.subscription.pause.yesPause") }}
      </eg-button>
    </template>
  </eg-modal>
</template>

<style lang="scss">
#pause_subscription_modal {
  font-family: Inter;

  .modal-body {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .img-content {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #dee2e6;

    img {
      margin-bottom: 16px;
    }
  }

  .modal-title {
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0px;
    vertical-align: bottom;
  }

  .bold-text {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0px;
    vertical-align: bottom;
  }

  .selection-block {
    display: flex;
    background-color: #f3e8fc;
    padding: 16px;
    border-radius: 4px;
    justify-content: space-between;

    .selection {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    .text {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0px;
    }

    .date {
      font-weight: 500;
      font-size: 24px;
      line-height: 28px;
      letter-spacing: 0px;
    }

    .renewal-info {
      display: flex;
      flex-direction: column;
      gap: 11px;
    }
  }

  .gap-3 {
    gap: 16px;
  }
}
</style>
